import { useNavigate } from "react-router-dom";
import { Tag } from "antd";
import { LeftOutlined } from "@ant-design/icons";

interface AudioArtifactTile {
  key: string;
  emoji: string;
  title: string;
  description: string;
  available: boolean;
  path?: string;
}

const TILES: AudioArtifactTile[] = [
  {
    key: "podcasts",
    emoji: "🎙",
    title: "Podcasts",
    description: "Full-length podcast episodes from QBR scores, objectives, weekly progress, and more",
    available: true,
    path: "/studio/audio/podcasts",
  },
  {
    key: "soundbites",
    emoji: "🔊",
    title: "Sound Bites",
    description: "Short 60–90 second audio summaries for quick sharing",
    available: false,
  },
  {
    key: "briefings",
    emoji: "📻",
    title: "Audio Briefings",
    description: "Spoken executive briefings and status updates",
    available: false,
  },
  {
    key: "recordings",
    emoji: "🎤",
    title: "Recordings",
    description: "Upload and manage your own audio files and transcripts",
    available: false,
  },
];

export const AudioHome = () => {
  const navigate = useNavigate();

  return (
    <div className="p-6 max-w-4xl mx-auto">
      {/* Breadcrumb */}
      <button
        onClick={() => navigate("/studio/home")}
        className="flex items-center gap-1 text-sm text-gray-400 hover:text-blue-600 mb-6 transition-colors"
      >
        <LeftOutlined style={{ fontSize: 11 }} />
        Studio
      </button>

      {/* Header */}
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-1">
          <div className="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center text-xl">
            🔊
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Audio</h1>
        </div>
        <p className="text-sm text-gray-400">
          AI-generated audio content from your team's data
        </p>
      </div>

      {/* Tile grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {TILES.map((tile) => (
          <button
            key={tile.key}
            disabled={!tile.available}
            onClick={() => tile.path && navigate(tile.path)}
            className={`
              text-left rounded-xl border p-5 flex flex-col gap-3 transition-all
              ${
                tile.available
                  ? "bg-white border-gray-200 hover:border-blue-400 hover:shadow-md cursor-pointer"
                  : "bg-gray-50 border-gray-100 cursor-not-allowed opacity-60"
              }
            `}
          >
            <div className="flex items-start justify-between">
              <div
                className={`
                  w-12 h-12 rounded-xl flex items-center justify-center text-2xl
                  ${tile.available ? "bg-blue-50" : "bg-gray-100"}
                `}
              >
                {tile.emoji}
              </div>
              {!tile.available && (
                <Tag color="default" className="text-xs">
                  Coming Soon
                </Tag>
              )}
            </div>
            <div>
              <div className="font-semibold text-gray-900 mb-0.5">{tile.title}</div>
              <div className="text-xs text-gray-400 leading-relaxed">{tile.description}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
